var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg78User(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 13,
    viewBox: "0 0 10 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.99928 6.13333C6.41681 6.13333 7.56595 4.9842 7.56595 3.56667C7.56595 2.14914 6.41681 1 4.99928 1C3.58175 1 2.43262 2.14914 2.43262 3.56667C2.43262 4.9842 3.58175 6.13333 4.99928 6.13333Z",
    fill: "black",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.39961 12.0001C9.39961 10.8331 8.93604 9.71399 8.11088 8.88883C7.28572 8.06367 6.16656 7.6001 4.99961 7.6001C3.83266 7.6001 2.7135 8.06367 1.88834 8.88883C1.06318 9.71399 0.599609 10.8331 0.599609 12.0001H9.39961Z",
    fill: "black",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg78User);
export default __webpack_public_path__ + "static/media/78-user.910709cfb9ede939416b0fcaae584a13.svg";
export { ForwardRef as ReactComponent };